import React from "react";
import { FormGroup as ReactstrapFormGroup, Label } from "reactstrap";
import classNames from "classnames";
import { compose } from "recompose";
import { Trans } from "react-i18next";
import { useFormikContext } from "formik";

export const FormGroup = ({
  label,
  check,
  inline,
  children,
  className,
  color,
  labelProps,
  ...props
}) => {
  return (
    <ReactstrapFormGroup
      color={color}
      className={classNames(className, { "form-check-inline": !!inline })}
      check={check}
      {...props}
    >
      {check ? (
        <Label check>
          {children}
          {!!label && [" ", <Trans key="trans">{label}</Trans>]}
        </Label>
      ) : (
        [
          !!label && (
            <Label key="label" {...labelProps}>
              <Trans>{label}</Trans>
            </Label>
          ),
          children,
        ]
      )}
    </ReactstrapFormGroup>
  );
};

const enhance = compose((BaseComponent) => (props) => {
  const formik = useFormikContext();
  let { name, className } = props;

  if (formik) {
    const touched = formik.touched[name];
    const error = formik.errors[name];

    if (touched && error) {
      className = classNames(className, "has-danger");
    } else if (touched && !error) {
      className = classNames(className, "has-success");
    } else if (!touched) {
      className = classNames(className, "has-warning");
    }
  }

  return <BaseComponent {...props} className={className} />;
});

export default enhance(FormGroup);
